"use client";
import React from "react";
import Image from "next/image";

import Button from "../../../components/ui/common/Button/page";
import Opensea from "@/public/assets/General-Img/Home/opensea.webp";
import Layer from "@/public/assets/General-Img/Home/layer.webp";
import Li from "@/public/assets/General-Img/Home/li.webp";
import Gmx from "@/public/assets/General-Img/Home/gmx.webp";
import curve from "@/public/assets/General-Img/Home/curve.webp";
import Caldela from "@/public/assets/General-Img/Home/caldela.webp";

import "../Marquees/Marquees.css";
import Marquee from "react-fast-marquee";

const Enterprise = () => {
  const marqueeData = [
    {
      id: 1,
      marqueeImage: Opensea,
      imageAlt: "Opensea",
    },
    {
      id: 2,
      marqueeImage: Layer,
      imageAlt: "Layer",
    },
    {
      id: 3,
      marqueeImage: Li,
      imageAlt: "Li",
    },
    {
      id: 4,
      marqueeImage: Gmx,
      imageAlt: "Gmx",
    },
    {
      id: 5,
      marqueeImage: curve,
      imageAlt: "curve",
    },
    {
      id: 6,
      marqueeImage: Caldela,
      imageAlt: "Caldela",
    },
  ];

  return (
    <>
      <div
        className="container mx-auto p-6 bg-[#FFFFFF] rounded-xl my-20"
        style={{
          boxShadow: "0px 0px 38px 0px #410EAD29",
        }}
      >
        <div className="bg-center bg-cover rounded-2xl bg-transparent h-min w-auto bg-[url('/assets/General-Img/Home/enterprise.webp')]">
          <div className="grid lg:grid-cols-12 md:p-10 ">
            <div className="lg:col-span-4 text-[#ffff] h-auto lg:text-start md:text-center text-center mt-5">
              <div className="lg:text-4xl md:text-4xl text-3xl font-bold">Enterprise</div>
              <div className="lg:text-xl md:text-xl text-sm mt-5  ">
                Volume Pricing, Unmatched <br /> Support, Custom SLAs.
              </div>
              <div
                className="flex lg:justify-start justify-center"
              >
                <Button className="common-blue-button-style mt-5">Initiate a Partnership</Button>
              </div>
            </div>
            <div className="lg:col-span-8 grid-rows-1  text-[#FFFFFF] lg:text-start  md:mt-5 lg:mt-0 mt-5 ml-5 xl:ml-0 mb-5">
              <div className="lg:grid lg:grid-cols-2  md:gap-5 xl:gap-0 md:mx-14 md:text-xl lg:mx-0">
                <div className="lg:mx-0 md:mt-5 lg:ml-0  mx-5 mt-2">24/7 Engineering Team Access</div>
                <div className="lg:mx-0 md:mt-5 lg:ml-0  mx-5 mt-2">Committed Usage Discounts</div>
              </div>
              <div className="lg:grid lg:grid-cols-2 md:mt-5 lg:mt-5 md:gap-5 xl:gap-0 md:mx-14 md:text-xl lg:mx-0">
                <div className="lg:mx-0 md:mt-5 lg:ml-0  mx-5 mt-2">Custom On-Demand discounts</div>
                <div className="lg:mx-0 md:mt-5 lg:ml-0  mx-5 mt-2">Custom Throughput Solutions</div>
              </div>
              <div className="lg:grid lg:grid-cols-2 md:mt-5 lg:mt-5 md:gap-5 xl:gap-0 md:mx-14 md:text-xl lg:mx-0">
                <div className="lg:mx-0 md:mt-5 lg:ml-0  mx-5 mt-2">24/7 VIP Support Channel</div>
                <div className="lg:mx-0 md:mt-5 lg:ml-0  mx-5 mt-2">Usage Optimization Reviews</div>
              </div>
              <div className="lg:grid lg:grid-cols-2 md:mt-5 lg:mt-5 md:gap-5 xl:gap-0 md:mx-14 md:text-xl lg:mx-0">
                <div className="lg:mx-0 md:mt-5 lg:ml-0  mx-5 mt-2">Guaranteed Response-Time SLAs</div>
                <div className="lg:mx-0 md:mt-5 lg:ml-0  mx-5 mt-2">Pay in Crypto</div>
              </div>
              <div className="lg:grid lg:grid-cols-2 md:mt-5 lg:mt-5 md:gap-5 xl:gap-0 md:mx-14 md:text-xl lg:mx-0">
                <div className="lg:mx-0 md:mt-5 lg:ml-0  mx-5 mt-2">SSO/Auth Managements Access</div>
                <div className="lg:mx-0 md:mt-5 lg:ml-0  mx-5 mt-2">Marketing Support via Amplify Pro</div>
              </div>

              <div className="lg:grid lg:grid-cols-2 md:mt-5 lg:mt-5 md:gap-5 xl:gap-0 md:mx-14 md:text-xl lg:mx-0">
                <div className="lg:mx-0 md:mt-5 lg:ml-0  ml-5 mt-2">Prioritized Alpha/Beta Access</div>
                <div className="lg:mx-0 md:mt-5 lg:ml-0  ml-5 mt-2">Flexible Custom terms</div>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-4 xl:mx-36 lg:mx-28 md:mx-16">
          <Marquee speed="10">
            {marqueeData.map((element, ind) => {
              return (
                <div className="mx-3 lg:mx-11" key={element.id || ind}>
                  <Image src={element.marqueeImage} alt={element.imageAlt} />
                </div>
              );
            })}
          </Marquee>
        </div>
      </div>
    </>
  );
};

export default Enterprise;
